import React from "react";

const TableHeader = ({
  column,
  label,
  handleSort,
  renderSortArrow,
  renderFilterButton,
}) => (
  <th onClick={() => handleSort(column)}>
    <div className="table-header-cell">
      {" "}
      {label} {renderSortArrow(column)}{" "}
      {renderFilterButton && renderFilterButton(column)}
    </div>
  </th>
);

export default TableHeader;
